import DndAPI from 'dashboard/api/contacts/dnd';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isEnabling: false,
    isDisabling: false,
  },
  meta: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  },
};

const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

const mutations = {
  SET_RECORDS($state, records) {
    $state.records = records;
  },
  SET_META($state, meta) {
    $state.meta = meta;
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetchDNDContacts({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await DndAPI.index(params);
      // Backend returns data wrapped in payload
      const contacts = response.data.payload || [];
      const meta = response.data.meta || {};

      commit('SET_RECORDS', contacts);
      commit('SET_META', meta);
      return contacts;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching DND contacts:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async enableDND({ commit }, { contactIds, reason }) {
    commit('SET_UI_FLAG', { isEnabling: true });
    try {
      const response = await DndAPI.enable(contactIds, reason);
      return response.data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error enabling DND:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isEnabling: false });
    }
  },

  async disableDND({ commit }, contactIds) {
    commit('SET_UI_FLAG', { isDisabling: true });
    try {
      const response = await DndAPI.disable(contactIds);
      return response.data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error disabling DND:', error);
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDisabling: false });
    }
  },

  async bulkEnableDND({ dispatch }, { contactIds, reason }) {
    return dispatch('enableDND', { contactIds, reason });
  },

  async bulkDisableDND({ dispatch }, contactIds) {
    return dispatch('disableDND', contactIds);
  },

  async checkDNDStatus(_, contactIds) {
    try {
      const response = await DndAPI.check(contactIds);
      return response.data.dnd_statuses;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error checking DND status:', error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
